import React from 'react';

import { IconButton } from '@bibliocommons/base-buttons';
import { Share, Print } from '@bibliocommons/base-icons';

import BackToLink from '../../../../shared/BackToLink';

import './HeaderBar.scss';

export default function HeaderBar() {
  return (
    <div className="cp-header-bar row">
      <BackToLink />
      <div className="print-share-buttons">
        <IconButton className="print-button" dataKey="print-button">
          <Print />
        </IconButton>
        <IconButton className="share-button" dataKey="share-button">
          <Share />
        </IconButton>
      </div>
    </div>
  );
}
